import gql from 'graphql-tag';

export default gql`
	mutation DriverAcceptFirebaseioDelete($id: ID!) {
		driverAcceptFirebaseioDelete(id: $id) {
			succeed
		}
	}
`;
